import React from 'react'
import classNames from 'classnames'
import { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import url from 'front-end-core/core/url'
import useObservable from 'front-end-core/hooks/useObservable'
import { PRECEDENTS_AUTOMATED_LISTINGS, PRECEDENTS_CONTENT } from 'constants/controllers'
import { getInterviewPath, getAutomatedListingPath } from 'services/PrecedentsService'
import Icon from 'components/shared/Icon'
import ResponseConsumer from 'components/shared/ResponseConsumer'

const BreadcrumbLink = ({ title, href, isFirst = false, isLast = false, isLink = true }) => {
  const Element = isLink
    ? 'a'
    : 'span'

  return (
    <div className='flex items-center'>
      {isFirst && (
        <Icon name='icon-precedents' className='w7 mr4' />
      )}
      <Element className={classNames('black no-underline f6', { 'hover-underline': isLink })} href={href}>
        {title}
      </Element>
      {!isLast && (
        <span className='mh4 f6'>
          {'>'}
        </span>
      )}
    </div>
  )
}

const Breadcrumbs = ({ aol, path, isInterview }) => (
  <div className='layout-width-constraint flex flex-wrap items-center pt9 pb3'>
    <BreadcrumbLink title='Precedents & Related Resources' href={url(PRECEDENTS_CONTENT, { aol, view: 'browse' })} isFirst />
    <BreadcrumbLink title={path[0].title} href={url(PRECEDENTS_AUTOMATED_LISTINGS, { aol, sectionId: path[0].id })} isLast={!isInterview} isLink={isInterview} />
    {isInterview && (
      <BreadcrumbLink title={path[1].title} href={url(PRECEDENTS_AUTOMATED_LISTINGS, { aol, sectionId: path[0].id, focusedId: path[1].id })} isLast />
    )}
  </div>
)

export default props => {
  const { aol, sectionId, interviewId = null } = props
  const isInterview = !(interviewId === null)
  const path = useObservable(
    isInterview
      ? getInterviewPath({ sectionId, aol, interviewId })
      : getAutomatedListingPath({ sectionId, aol }),
    RESPONSE_PENDING
  )

  return (
    <ResponseConsumer
      response={path}
      content={() => <Breadcrumbs aol={aol} path={path} isInterview={isInterview} />}
    />
  )
}
